import { useStoreState } from '@ariakit/react';
import { Disclosure, DisclosureContent, useDisclosureStore } from '@ariakit/react/disclosure';
import cn from 'classnames';
import { Spindown } from '#components/atoms/spindown/Spindown.tsx';
import styles from './FAQRow.module.css';

type Props = {
  summary: React.ReactNode;
  children: React.ReactNode;
};

export function FAQRow({ summary, children }: Props) {
  const disclosure = useDisclosureStore();
  const isOpen = useStoreState(disclosure, 'open');

  return (
    <div>
      <h3 className="m-0">
        <Disclosure store={disclosure} className={cn('h6 mb-0', styles.FAQRow_disclosure)}>
          <Spindown className={styles.FAQRow_spindown} isExpanded={isOpen} /> {summary}
        </Disclosure>
      </h3>
      <DisclosureContent className={styles.FAQRow_disclosureContent} store={disclosure}>
        <p className="p-md mt-8">{children}</p>
      </DisclosureContent>
    </div>
  );
}
